import React, { useEffect, useState } from "react";
import "./PaymentAnalytics.scss";
import DonoughtChart from "../Charts/DonoughtChart/DonoughtChart";
import { useSelector } from "react-redux";

const colors = ["#092B3A", "#65C1E8", "#C1E6F6", "#DCF2FB", "#115774"];

const PaymentAnalytics = () => {
  const { currency } = useSelector((state) => state.organizationReducer.value);
  const { paymentMethodsAnalytics: paymentMethodsAnalyticsData } = useSelector(
    (state) => state.analyticsReducer
  );

  const [totalData, setTotalData] = useState({
    revenue: 0,
    sales: 0,
  });

  const [totalPayLaterData, setTotalPayLaterData] = useState({
    revenue: 0,
    sales: 0,
  });

  const [totalStoreCreditData, setTotalStoreCreditData] = useState({
    revenue: 0,
    sales: 0,
  });

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: [],
        borderWidth: 6,
      },
    ],
  });

  useEffect(() => {
    const labels = [];

    const dataSet = [];

    let temp_revenue = 0;
    let temp_sales = 0;

    paymentMethodsAnalyticsData?.revenue_by_payment_method?.forEach((el) => {
      if (
        el?.payment_method !== "credit" &&
        el?.payment_method !== "pay_later"
      ) {
        temp_revenue += el?.amount || 0;
        temp_sales += el?.sales || 0;
        if (labels.length < 5) {
          labels.push(el?.label || "N/A");
          dataSet.push(el?.amount);
        } else {
          if (labels.length === 5) {
            labels[4] = "Others";
            dataSet[4] = (dataSet[4] || 0) + el?.amount || 0;
          } else {
            dataSet[4] += el?.amount || 0;
          }
        }
      } else {
        if (el?.payment_method === "credit") {
          let revenue = el?.amount || 0;
          setTotalStoreCreditData({
            revenue: Number(revenue).toFixed(2),
            sales: el?.sales || 0,
          });
        } else if (el?.payment_method === "pay_later") {
          let revenue = el?.amount || 0;
          setTotalPayLaterData({
            revenue: Number(revenue).toFixed(2),
            sales: el?.sales || 0,
          });
        }
      }
    });

    setData({
      labels: labels,
      datasets: [
        {
          data: dataSet,
          backgroundColor: colors,
          borderWidth: 6,
        },
      ],
    });

    setTotalData({
      revenue: Number(temp_revenue).toFixed(2),
      sales: temp_sales,
    });
  }, [paymentMethodsAnalyticsData]);

  return (
    <div className="payment-analytics">
      <div className="container-wrapper paymentAnalytics">
        <div className="payment-chart">
          <div className="chart-container">
            <div className="info-container">
              <p className="title">
                {totalData.sales} / {currency}
                {totalData.revenue}
              </p>
              <p>Number of Payments</p>
            </div>
            <DonoughtChart data={data} isHalf={true} currency={currency} />
          </div>

          <div className="chart-labels">
            {data?.labels?.map((el, i) => {
              return (
                <div className="label" key={i}>
                  <span
                    className="dot"
                    style={{
                      backgroundColor: `${colors[i]}`,
                    }}
                  ></span>
                  <p>
                    <span
                      style={{
                        color: `${colors[i]}`,
                      }}
                    >
                      {(
                        Number(data.datasets[0].data[i] / totalData.revenue) *
                        100
                      ).toFixed(2)}
                      %
                    </span>{" "}
                    {el}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <p className="heading">Payment Record</p>

        <div className="revenue-table">
          <div className="row head">
            <p>Type</p>
            <p>QTY</p>
            <p>Amount</p>
            <p>%</p>
          </div>

          <div className="table-body">
            {paymentMethodsAnalyticsData?.revenue_by_payment_method?.filter(item=> item?.payment_method !== "credit" && item?.payment_method !== "pay_later")?.map(
              (el, i) => {
                return (
                  <div className="row" key={i}>
                    <p style={{ color: `${colors[i]}` }}>
                      {el?.label || "N/A"}
                    </p>
                    <p>{el?.sales || 0}</p>
                    <p>
                      {currency}
                      {Number(el?.amount).toFixed(2) || "0.00"}
                    </p>
                    <p>
                      {Number((el?.amount / totalData.revenue) * 100).toFixed(
                        2
                      ) || 0}
                      %
                    </p>
                  </div>
                );
              }
            )}

            <div className="row total">
              <p>Total</p>
              <p>{totalData?.sales || 0}</p>
              <p>
                {currency}
                {totalData?.revenue || "0.00"}
              </p>
              <p>{totalData?.revenue ? "100%" : "0.00%"}</p>
            </div>

            <div className="row store-credit">
              <p>Sales on pay later</p>
              <p>{totalPayLaterData.sales || 0}</p>
              <p>{currency}{totalPayLaterData.revenue || '0.00'}</p>
              <p></p>
            </div>

            <div className="row store-credit" style={{marginBottom: '20px'}}>
              <p>Sales on store credit</p>
              <p>{totalStoreCreditData.sales || 0}</p>
              <p>{currency}{totalStoreCreditData.revenue || '0.00'}</p>
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentAnalytics;
